var _path;
import React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M6.65 8.329l-6.3 6.3a1.19 1.19 0 001.684 1.677l7.139-7.134a1.188 1.188 0 00.035-1.641L2.039.347A1.19 1.19 0 10.353 2.028z",
    fill: "#fff"
  })));
};
export default SvgRightArrow;